import { render } from "./MedicalRecordPrinter.vue?vue&type=template&id=e6b0783a"
import script from "./MedicalRecordPrinter.vue?vue&type=script&lang=js"
export * from "./MedicalRecordPrinter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__